module.exports = __webpack_public_path__ + "img/img01.54f94084.png";